import React, { Component, PropTypes } from 'react'
import { surplusTime, createUrl } from '../../common/utils'
import t from '../../i18n/purchase'

export class ColorPic extends Component {
	constructor(props){
		super(props)		
	}
	componentDidMount(){
		//script标签直接引入swiper文件
		const galleryTop = new Swiper('.gallery-top', {
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
		const galleryThumbs = new Swiper('.gallery-thumbs', {
			centeredSlides: true,
			slidesPerView: 5,
			touchRatio: 0.2,
			slideToClickedSlide: true,
		});
		galleryTop.controller.control = galleryThumbs;
		galleryThumbs.controller.control = galleryTop;
	}
	render() {
        const { currColor, hasSoldout } = this.props                  
        const picListDom = (isBigPic) => {
            let listConfig = [1, 2, 3, 4, 5]            
            const name = isBigPic ? '' : '_sml'           
            let list = listConfig.map(index => {
                return <li className="swiper-slide" key={index}><img src={`../../images/purchase/products/pic_${currColor}${name}_${index}.jpg`} alt="" /></li>
            })           
            return <ul className="swiper-wrapper">{list}}</ul>
        }        

        const soldOutDom = hasSoldout ?
            <div className="np-feature-none">				
				<div className="np-feature-none-tb">
					<p>{t('pic_soldout')}</p>
					<a href={createUrl('site/index')} target="_blank">{t('more')} &gt;</a>
				</div>
            </div> : null        
                
		return (
			<div className="np-buy-feature">
                <div className="np-feature-big">
                    <div className="swiper-container gallery-top swiper-container-horizontal">
                        { picListDom(true) }
                        <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
                    </div>
                    { soldOutDom }
                </div>
                <div className="np-feature-bullet">
                    <div className="swiper-container gallery-thumbs swiper-container-horizontal">
                    { picListDom(false) }
                    </div>
                </div>
            </div>
		)
	}
}

ColorPic.propTypes = {	
	currColor: PropTypes.string.isRequired,	
}
ColorPic.defaultProps = {
	hasSoldout: false
}

export class Countdown extends Component {
	render(){
		const { currTime, targetTime, desc } = this.props
		if(!currTime || !targetTime) return null
        const time = surplusTime(currTime, targetTime)
        const [desc1, desc2] = desc.split('|')
        
		return (			
            <div className="np-buy-seckill">{desc1}
                <em>
                    {desc2}
                    {time.day>0 ? <span>{time.day}{t('date_day')}</span> : null}
                    <span>{time.hour}{t('date_hour')}</span>
			        <span>{time.minute}{t('date_minute')}</span>
			        <span>{time.second}{t('date_second')}</span>                   
                </em>
            </div>           
		)		
	}
}
Countdown.propTypes = {
	currTime: PropTypes.instanceOf(Date).isRequired,
	targetTime: PropTypes.instanceOf(Date),
    type: PropTypes.string,    
}
Countdown.defaultProps = {
    desc: ''
}

export class ColorSelector extends Component {
	constructor(props){
		super(props)
		this.switchColor = this.switchColor.bind(this)
	}
	switchColor(e){
		this.props.onChange($(e.currentTarget).data('color'))
	}

	render() {
        const { colorConfig, currColor, showZeroColor } = this.props
        const colorCls = {
            black: 'np-dot-black',
            blue: 'np-dot-blue',
            orange: 'np-dot-org'
        }
		return (
            <div className="np-buy-unit">
                <dl className="np-buy-color">
                    <dt>{t('notifi_selectcolor')}</dt>
                {
			    	colorConfig.map(item => {
						let ret = null
						if (item.has) {
							ret = <dd className={currColor==item.color ? 'np-selected' : ''} key={item.color} onClick={this.switchColor} data-color={item.color}>
								<i className={colorCls[item.color]}></i>
								{item.text}
							</dd>
						} else if (showZeroColor) {
							ret = <dd className={'np-buy-soldout'} key={item.color} data-color={item.color}>
								<i className={colorCls[item.color]}></i>
								{item.text}{t('colorcom_zero')}
							</dd>
						}						
			    		return  ret
			    	})
			    }                   
                </dl>
            </div>			
		)
	}
}
ColorSelector.propTypes = {
	colorConfig: PropTypes.array.isRequired,
	currColor: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired
}
ColorSelector.defaultProps = {
	showZeroColor: true
}

/**
 * 消息弹窗
 * 
 * @export
 * @class TipPop
 * @extends {Component}
 * msg——弹窗主体内容，支持html元素
 * jump—— 如果存在，并为函数，则点击执行自定义函数
 * 		  如果存在，并且为字符串，则点击跳转到自定义链接
 * 		  其他情况，默认确认按钮为关闭弹窗
 * onClose——如果为函数，则为关闭弹窗的回调函数
 * 			如果为false，则不设置确认按钮和关闭按钮
 * btnTxt——按钮文字 
 * 
 */
export class TipPop extends Component {
	constructor(props){
		super(props)
		this.btnRender = this.btnRender.bind(this)
	}

	btnRender(){
		const {jump,onClose,btnTxt} = this.props;
		let jumpType = jump && typeof jump ;
		let noBtnRender = ()=>{
			return <div className="oc-pop-btnbox"></div>
		}
		let btnRenderInner = ()=>{
			let submitBtn = ()=>{
				if(jumpType=='function'){ 
					return <a href="javascript:;" className="btn-oc" onClick={()=>{jump();onClose()}}>{btnTxt}</a>
				}else if(jumpType=='string'){
					if(jump=='cart') return <div>
						<a href="javascript:;" className="btn-oc btn-oc-line" onClick={onClose}>继续购物</a>
						<a href="/site/cart.html" className="btn-oc" >查看购物车</a>
					</div>
					return <a href={jump} className="btn-oc">{btnTxt}</a>
				}else {
					return <a href="javascript:;" className="btn-oc" onClick={onClose}>{btnTxt}</a>
				}
			}
			return <div>
				<div className="oc-pop-btnbox">
					{submitBtn()}
				</div>
				<a href="javascript:;" className="oc-pop-close" onClick={onClose}>{t('close')}</a>
			</div>
		}
		return onClose ? btnRenderInner() : noBtnRender()
	}

	render() {
		const {msg, jump, onClose,btnTxt} = this.props;
		let dangerousInnerHTML = {
			__html: msg
		}
		return (
			<div className="oc-pop">
				<div className="oc-pop-wp">
					<div className="oc-pop-textbox oc-tb">
						<div className="oc-pop-text oc-tb-cell"
							dangerouslySetInnerHTML={dangerousInnerHTML}>
							
						</div>
					</div>
					{this.btnRender()}
				</div>
			</div>
		)
	}
}
TipPop.defaultProps = {
	msg: 'hello breeze',
	jump: '',
	onClose: ()=> function() {},
	btnTxt: t('ok')
}

export function jumpToLogin () {
    location.href = `${createUrl('html/login')}?jumpurl=${encodeURIComponent(location.href)}`;
}

export class DiskContainer extends Component {
	constructor(props) {
		super(props) 	
		this.state = {
			showDiskDetail: false,
			diskChecked: false
		}		
	}

	handleDiskDetailClick = () => {
		this.setState({showDiskDetail: !this.state.showDiskDetail})
	}

	handleDiskChange = () => {		
		this.setState({diskChecked: !this.state.diskChecked}, this.updateDiskData)
	}

	updateDiskData() {
		const { diskChecked } = this.state
		this.props.updateDiskData({diskChecked})
	}

	render() {
		const { diskPrice, diskCount, updateDiskData } = this.props	
		const { showDiskDetail, diskChecked } = this.state
		const diskDiscountPrice = diskPrice - diskCount	
		const foldCls = showDiskDetail ? 'i-np-fold i-np-unfold' : 'i-np-fold'

		return <div className="np-buy-groups">
					<h3>请选择搭配移动硬盘</h3>
					<div className="np-buy-groups-item">
						<div className="np-buy-gibox">
							<div className="np-checkbox">
								<input type="checkbox" checked={diskChecked} onChange={this.handleDiskChange} />
								<i className="i-np-check"></i>
							</div>
							<img src="../../images/purchase/disk_sml.png" alt="" onClick={this.handleDiskChange} />
							<div className="np-buy-gi-theme" onClick={this.handleDiskChange}>
								<h4>希捷2TB黑钻移动硬盘</h4>
								<div className="np-buy-gi-price">
									<em>{diskDiscountPrice}元</em>
									<del>{diskPrice}元</del>
								</div>
							</div>
							<em className="np-lbl-discount"><i>省{diskCount}元</i></em>						
							<i id="fold" className={foldCls} title="查看详情" onClick={this.handleDiskDetailClick}></i>
						</div>
						{ showDiskDetail && <DiskDetail /> }
					</div>
				</div>
	}
}


const DiskDetail = () => {
	return <div className="np-buy-groups-detail">
				<div className="np-buy-groups-detail-tb">
					<h4>主体</h4>
					<table>
						<tbody>
						<tr>
							<th>品牌</th>
							<td>希捷 Seagate</td>
						</tr>
						<tr>
							<th>系列</th>
							<td>Expansion</td>
						</tr>
						<tr>
							<th>型号</th>
							<td>STEA2000400</td>
						</tr>
						<tr>
							<th>类型</th>
							<td>便携式存储</td>
						</tr>
						<tr>
							<th>外壳颜色</th>
							<td>黑色</td>
						</tr>
						<tr>
							<th>外壳材质</th>
							<td>塑料</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div className="np-buy-groups-detail-tb">
					<h4>规格</h4>
					<table>
						<tbody>
						<tr>
							<th>容量</th>
							<td>2TB</td>
						</tr>
						<tr>
							<th>外部输出接口</th>
							<td>USB3.0</td>
						</tr>
						<tr>
							<th>系统要求</th>
							<td>Win10；win7；win8</td>
						</tr>
						<tr>
							<th>硬盘尺寸</th>
							<td>2.5英寸</td>
						</tr>
						<tr>
							<th>指示灯</th>
							<td>有</td>
						</tr>
						<tr>
							<th>尺寸（mm）</th>
							<td>117*80*14.8mm</td>
						</tr>
						<tr>
							<th>重量（g）</th>
							<td>170g</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div className="np-buy-groups-detail-tb">
					<h4>包装清单</h4>
					<p className="np-buy-groups-detail-sum">移动硬盘x1、USB 3.0连接线 x1、快速入门指南 x1</p>
				</div>
			</div>
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/componentsv2.js